const SendChatInputIcon = (props) => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 28 28" 
        fill={props.color} 
        width="28" 
        height="28"
      >
        <path d="M2 21l21-9L2 3v7l15 2-15 2v7z" />
      </svg>
    </>
  );
};

export default SendChatInputIcon;
